module.exports = __webpack_public_path__ + "img/78ne.a15d3417.svg";